import { css, html, LitElement } from 'lit-element';
import i18n from '@giswebgroup/ki-wcp-base/src/decorators/i18n';
import nls from '../../locales/index.nls';

export default
@i18n(nls)
class KiStationImg extends LitElement {
  // language=CSS
  static styles = css`
    .image-wrapper {
      height: 100%;
      text-align: center;
    }
    .image-wrapper img {
      max-width: 100%;
    }
    #close-btn {
      position: absolute;
      z-index: 11;
      top: 20px;
      right: 20px;
    }
  `;

  static get properties() {
    return {
      src: { type: String },
    };
  }

  render() {
    // language=html
    return html` <div class="image-wrapper"><img src="${this.src}" /></div>
      <ki-icon-btn id="close-btn" icon="ki ki-times" @click="${this.closeElement}"></ki-icon-btn>
      <paper-tooltip for="close-btn">${this.i18n.t('closeView')}</paper-tooltip>`;
  }

  closeElement() {
    this.dispatchEvent(
      new CustomEvent('close', {
        bubbles: true,
        composed: true,
      }),
    );
  }
}

customElements.define('ki-station-img', KiStationImg);
